import {React, useState} from 'react'
import { Link } from 'react-router-dom';
import "../../../styles/inicio/inicio.css"
import Logo from "../../Reutilizables/Logo"
import Menu from "../../Reutilizables/Menu"
import Redes from '../../Reutilizables/Redes'
import Footer from '../../Reutilizables/Footer'
import ModalInicio from './ModalInicio'
import TituloImpuestosMunicipales from '../../Reutilizables/TituloImpuestosMunicipales'

function Inicio() {

  const [modals, setModals] = useState({}); // Estado para controlar las ventanas modales

  const openModal = (modalKey) => {
    setModals((prevModals) => ({
      ...prevModals,
      [modalKey]: true,
    }));
  };

  const closeModal = (modalKey) => {
    setModals((prevModals) => ({
      ...prevModals,
      [modalKey]: false,
    }));
  };

  const modalData = {
    vinculoVital: {
      content: (
        <>
        </>
      ),
    },
    servicios: {
      content: (
        <>
        </>
      ),
    },
    guiaImpuestos: {
      content: (
        <>
        </>
      ),
    },
    planificacionFiscal: {
      content: (
        <>
        </>
      ),
    },

    /* ---------------------------------------------------------------------------------------------------------------------------- */
    cambiosLegales: {
      content: (
        <>
        </>
      ),
    },
    concejosPracticos: {
      content: (
        <>
        </>
      ),
    },
    inversiones: {
      content: (
        <>
        </>
      ),
    },
    planificacionJubilacion: {
      content: (
        <>
        </>
      ),
    },
  };

  return (
      <div className='inicon'>
        <div className='container-logo-menu'> 
          <Logo />
          <Menu />
        </div>
        <TituloImpuestosMunicipales />
        <Redes />
        <div className='inicio-publicidad'>
          <div className='inicio-publicidad-2'>
          
            

            <div className='titulo-publicidad'>
              TRIBUTOS Y FINANZAS

              <Link to="/nuestros-clientes">
                <div className='logo-publicidad'>
                </div>
              </Link>

            </div>

            <section className='info-beneficios-publicidad'>
			        <div> 
                ¿No se ha registrado aún? 
			        </div> 
              Descubra los beneficios al  
              <Link to="registrarse"> suscribirse </Link>
			        a
			        <a href="/ventajas" target="blank"> Tributos y Finanzas.</a>
		        </section>

          </div>
        </div>

        <div className="container-inicio">

            {/* seccion 1 */}

            <div className="card">
              <div className="content">
                <span>
                  <span className="title">
                    <i className="fa-solid fa-link"></i>
                    Vínculos
                  </span>
                </span>
                <p className="desc">
                  El vínculo vital entre impuestos, finanzas personales y bienestar financiero.
                </p>
                <button onClick={() => openModal('vinculoVital')} className="action">
                  Leer mas
                  <span aria-hidden="true">
                    →
                  </span>
                </button>
              </div>
            </div>

            {/* seccion 2 */}

            <div className="card">
              <div className="content">
                <span>
                  <span className="title">
                    <i className="fa-solid fa-house"></i>
                    Servicios
                  </span>
                </span>
                <p className="desc">
                Nuestros servicios incluyen:
                </p>
                <button onClick={() => openModal('servicios')} className="action">
                  Leer mas
                  <span aria-hidden="true">
                    →
                  </span>
                </button>
              </div>
            </div>

            {/* seccion 3 */}

            <div className="card">
              <div className="content">
                <span>
                  <span className="title">
                    <i className="fa-solid fa-table"></i>
                    Guías
                  </span>
                </span>
                <p className="desc">
                  Guía para completar la declaración de impuestos y optimizar beneficios fiscales.
                </p>
                <button onClick={() => openModal('guiaImpuestos')} className="action">
                  Leer mas
                  <span aria-hidden="true">
                    →
                  </span>
                </button>
              </div>
            </div>

            {/* seccion 4 */}

            <div className="card">
              <div className="content">
                <span>
                  <span className="title">
                    <i className="fa-solid fa-bullseye"></i>
                    Estrategias
                  </span>
                </span>
                <p className="desc">
                  Estrategias de planificación fiscal.
                </p>
                <button onClick={() => openModal('planificacionFiscal')} className="action">
                  Leer mas
                  <span aria-hidden="true">
                    →
                  </span>
                </button>
              </div>
            </div>

          {/* ----------------------------------------------------------------------------------------- */}

            {/* seccion 5 */}

            <div className="card">
              <div className="content">
                <span>
                  <span className="title">
                    <i className="fa-solid fa-file"></i>
                    Cambios
                  </span>
                </span>
                <p className="desc">
                  Cambios legales y actualizaciones fiscales.
                </p>
                <button onClick={() => openModal('cambiosLegales')} className="action">
                  Leer mas
                  <span aria-hidden="true">
                    →
                  </span>
                </button>
              </div>
            </div>

          {/* seccion 6 */}

          <div className="card">
              <div className="content">
                <span>
                  <span className="title">
                    <i className="fa-solid fa-list-check"></i>
                    Administración
                  </span>
                </span>
                <p className="desc">
                  Administra de manera efectiva los ingresos, gastos y ahorros.
                </p>
                <button onClick={() => openModal('concejosPracticos')} className="action">
                  Leer mas
                  <span aria-hidden="true">
                    →
                  </span>
                </button>
              </div>
          </div>

          {/* seccion 7 */}

          <div className="card">
              <div className="content">
                <span>
                  <span className="title">
                    <i className="fa-solid fa-warehouse"></i>
                    Decisiones
                  </span>
                </span>
                <p className="desc">
                  Decisiones de inversión.
                </p>
                <button onClick={() => openModal('inversiones')} className="action">
                  Leer mas
                  <span aria-hidden="true">
                    →
                  </span>
                </button>
              </div>
          </div>

          {/* seccion 8 */}

          <div className="card">
              <div className="content">
                <span>
                  <span className="title">
                  <i className="fa-sharp fa-solid fa-clock-rotate-left"></i>
                    Planificaciones
                  </span>
                </span>
                <p className="desc">
                  Planificación de jubilación y pensiones.
                </p>
                <button onClick={() => openModal('planificacionJubilacion')} className="action">
                  Leer mas
                  <span aria-hidden="true">
                    →
                  </span>
                </button>
              </div>
          </div>

          {Object.keys(modals).map((modalKey) => (
            <ModalInicio
              key={modalKey}
              isOpen={modals[modalKey]}
              closeModal={() => closeModal(modalKey)}
              content={modalData[modalKey]?.content}
            />
          ))}

        </div>
        <Footer />
      </div>
  )  
}

export default Inicio